document.addEventListener("DOMContentLoaded", () => {
  let menuFristInit = true;
  let drawerFristInit = true;

  const useDrawerMQL = window.matchMedia(`(max-width: 1199px)`);
  useDrawerMQL.addEventListener('change', (event) => {
    if (event.matches && drawerFristInit) {
      initDrawer();
    }
    if (!event.matches && menuFristInit) {
      initMenus();
    }
  });
  useDrawerMQL.matches ? initDrawer() : initMenus();

  // Large PC Menus
  function initMenus() {
    menuFristInit = false;
    const details = document.querySelectorAll(".header-wrapper details.mega-menu");
    const summary = document.querySelectorAll(
      ".header-wrapper .mega-menu summary.header__menu-item"
    );
    summary.forEach((menu, index) => {
      menu.addEventListener("mouseover", () => {
        menu.parentElement.open = true;
        summary.forEach((menu, i) => {
          if (i !== index) {
            menu.parentElement.open = false;
          }
        });
      });
      menu.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          menu.mouseover();
        }
      });
    });
    details.forEach((menu) => {
      menu.addEventListener("mouseleave", () => {
        summary.forEach((menu) => {
          menu.parentElement.open = false;
        });
      });
    });
  }

  // Mobile Drawer
  function initDrawer() {
    drawerFristInit = false;

    // Menus lv1
    for (const element of document.querySelectorAll(".header-wrapper [data-toggle-menu-mb]")) {
      element.addEventListener('keydown', () => {
        if (e.key == "Enter" || e.key == "") {
          const summary = element.closest('summary');
          !!summary ? summary.click() : element.click();
        }
      });
      // 阻止level 1 a链接冒泡导致，页面刷新前，菜单栏空白
      element.previousElementSibling?.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }

    // Skip
    for (const element of document.querySelectorAll(".header-wrapper .menu-last-focusable-element")) {
      element.addEventListener('keydown', (e) => {
        if (e.key == "Enter" || e.key == "Tab") {
          $(element).parents(".no-mega-menu").removeClass("active");
          if ($(window).innerWidth() < 1200) {
            $(element).parents(".sub-menu-mobile").find("[data-back-menu]").focus();
          }
        }
      });
    }

    // Menus lv2
    const subMenuList = document.querySelectorAll('.header-wrapper [data-sub-menu-details]');
    /**
     * @param {HTMLElement} subMenu 
     */
    function renderToggleButtonIcon(toggleButton, expanded) {
      const dataIndex = toggleButton.getAttribute('data-index');
      if (expanded) {
        toggleButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" aria-labelledby="icon-minus-title-${dataIndex}" focusable="false" class="icon icon-minus" fill="none"viewBox="0 0 10 2"><title id="icon-minus-title-${dataIndex}">Minus</title><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></svg>`;
      } else {
        toggleButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" aria-labelledby="icon-plus-title-${dataIndex}" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><title id="icon-plus-title-${dataIndex}">Plus</title><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></svg>`;
      }
    }
    for (const subMenu of subMenuList) {
      const toggleButton = subMenu.querySelector('[data-dropdown-toggle-btn]');
      toggleButton?.addEventListener('click', () => {
        const content = subMenu.querySelector('summary')?.nextElementSibling;
        if (!subMenu) return;
        if (subMenu.classList.contains('sub-menu-open')) {
          // close
          renderToggleButtonIcon(toggleButton, false);
          content?.setAttribute('aria-expanded', 'false');
          subMenu.classList.remove('sub-menu-open');
          $(content).slideUp();
        } else {
          // open
          renderToggleButtonIcon(toggleButton, true);
          content?.setAttribute('aria-expanded', 'open');
          subMenu.classList.add('sub-menu-open');
          $(content).slideDown();
        }
      });

      toggleButton?.addEventListener('keydown', (e) => {
        if (e.key == "Enter" || e.key == "") {
          toggleButton.click();
        }
      });
    }
  }
});
